import { Link } from "react-router-dom";
import { Eyebrow, Reveal } from "../components/Shared";
import { SERVICES } from "../data/site";

const ServiceCard = ({ service, index }) => (
  <Reveal delay={(index % 3) * 0.1} className="h-full">
    <article
      className="card group relative flex h-full flex-col overflow-hidden transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-[0_12px_32px_-16px_rgba(23,78,166,0.25)]"
      data-testid={`service-card-${service.num}`}
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={service.image}
          alt={service.name}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/30 to-transparent" />
        <span className="absolute left-4 top-4 rounded-md bg-white/90 px-2.5 py-1 text-[11px] font-semibold tracking-[0.16em] text-brand backdrop-blur-sm">
          {service.num}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-7">
        <h3 className="font-display text-xl font-bold tracking-tight text-navy">{service.name}</h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-slate">{service.desc}</p>
        <Link
          to="/services"
          data-testid={`service-learn-more-${service.num}`}
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand2 transition-colors hover:text-brand"
        >
          Learn More
          <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
        </Link>
      </div>
    </article>
  </Reveal>
);

const ServicesSection = ({ showAll = true }) => (
  <section className="relative bg-white py-24 sm:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <Reveal>
            <Eyebrow>02 — Our Services</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 max-w-xl font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
              Commercial print solutions, executed with precision.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-slate">
            From high-volume offset work to retail display material — every job receives the same meticulous care.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {(showAll ? SERVICES : SERVICES.slice(0, 6)).map((s, i) => (
          <ServiceCard key={s.num} service={s} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
